import React, { useEffect, useMemo, useState } from 'react';
import { fetchQueries } from '../../api/Query';
import { Query } from '../../types/Query';
import '../../css/modal.css';

interface Props {
  onClose: () => void;
  onSelect: (query: Query) => void;
}

const QueryPickerModal: React.FC<Props> = ({ onClose, onSelect }) => {
  const [queries, setQueries] = useState<Query[]>([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState('');

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        setLoading(true);
        const data = await fetchQueries();
        if (mounted) setQueries(Array.isArray(data) ? data : []);
      } catch (e) {
        if (mounted) setQueries([]);
      } finally {
        if (mounted) setLoading(false);
      }
    })();
    return () => { mounted = false; };
  }, []);

  const filtered = useMemo(() => {
    const q = search.trim().toLowerCase();
    if (!q) return queries;
    return queries.filter(it =>
      (it.customer?.name || '').toLowerCase().includes(q) ||
      (it.type || '').toLowerCase().includes(q) ||
      (it.description || '').toLowerCase().includes(q) ||
      (it.location || '').toLowerCase().includes(q)
    );
  }, [queries, search]);

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal" onClick={e => e.stopPropagation()} style={{ width: 560 }}>
        <button className="close-btn" onClick={onClose}>&times;</button>
        <h2>Select Query</h2>
        <input
          type="text"
          placeholder="Search by customer, type, description, or location"
          value={search}
          onChange={e => setSearch(e.target.value)}
        />
        <div style={{ maxHeight: 320, overflowY: 'auto', marginTop: 8 }}>
          {loading && <div>Loading…</div>}
          {!loading && filtered.length === 0 && <div>No queries found</div>}
          {!loading && filtered.map(q => (
            <div key={q.id} style={{ padding: '8px 6px', borderBottom: '1px solid #eee', cursor: 'pointer' }}
                 onClick={() => onSelect(q)}>
              <div style={{ fontWeight: 600 }}>{q.customer?.name || 'Customer'}</div>
              <div style={{ fontSize: 12, color: '#555' }}>
                {q.type} — {q.description} · {q.location}
              </div>
            </div>
          ))}
        </div>
        <div className="modal-actions">
          <button onClick={onClose} className="secondary">Close</button>
        </div>
      </div>
    </div>
  );
};

export default QueryPickerModal;

